// 案件担当者セレクト管理
import commonClass from "./commonClass";

export default class variableSelectClass extends commonClass {
  // コンストラクタ
  constructor() {
    super();
    this._getSuper();
    this._classValiableDefine();

    this._init();
  }

  // 親classから変数を取得してくる
  _getSuper() {
  }
  // class変数定義
  _classValiableDefine() {
    this._templateSelector = '.js-variableslct_tmpl';
    this._containerSelector = '.js-variableslct_ctnr';
    this._parentSelector = '.js-variableslct_prt';
    this._addTrgSelector = '.js-variableslct_trg_add';
    this._delTrgSelector = '.js-variableslct_trg_del';
  }


  // 初期化用関数
  _init() {
    this._main();
  }

  // リサイズ用関数
  _resize() {
  }

  // メイン処理
  _main() {
    var cls = this;

    $(cls._containerSelector).each(function (index, el) {
      var $self = $(el);
      var $tmp = cls._getTemplate($self);

      $self.on('click', cls._addTrgSelector, function () {
        cls._add($self, $tmp);
      });

      $self.on('click', cls._delTrgSelector, function () {
        cls._del($(this), $self);
      });
    });
  }

  // テンプレ取得
  _getTemplate($ctnr) {
    var cls = this;

    var $tmp = $ctnr.find(cls._templateSelector).clone();
    $ctnr.find(cls._templateSelector).remove();

    return $tmp;
  }

  // セレクト追加処理
  _add($ctnr, $tmp) {
    var cls = this;

    // 追加で増えるオプションは未選択とする
    $tmp.find("select option").attr("selected", false);

    $tmp.clone().appendTo($ctnr).fadeIn();
    cls._updateBtnView($ctnr);
    return false;
  }

  // セレクト削除処理
  _del($ctnr, $self) {
    var cls = this;

    $ctnr.closest(cls._parentSelector).remove();
    cls._updateBtnView($self);
    return false;
  }

  // 追加/削除ボタン表示更新
  _updateBtnView($ctnr) {
    var cls = this;
    var $tgt = $ctnr.find(cls._parentSelector);
    $tgt.removeClass('is-del is-add is-lastrow');

    for (var i = 0; i < $tgt.length; i++) {
      if ($tgt.length === 1) {
        $tgt.addClass('is-add');
        continue;
      }
      if (i === $tgt.length - 1) {
        $tgt.eq(i).addClass('is-lastrow');
        continue;
      }
      $tgt.eq(i).addClass('is-del');
    }
  }

  // 初期化（frmClearClassから呼び出し実行）
  // $trg: 初期化実行のトリガーになるjQueryオブジェクト
  _reinit($trg) {
    var cls = this;
    // frmClearのトリガーから初期化対象のvariableslct要素を取得
    var $prt = $trg.closest('.js-frmclr').find(cls._containerSelector);
    // 初期化のため、不要なクラスを削除しておく
    $prt.children().eq(0).removeClass('is-del is-add is-lastrow').find('select').removeClass('has-val');
    $prt.children().eq(0).find('input[type="text"]').removeClass('has-val').val('');
    var $html = $prt.children().eq(0);

    // select要素を全て削除
    $prt.empty();

    // "クリア"ボタン押下時に描画されるselect要素
    $html.clone().appendTo($prt).addClass('is-add');
  }
}